module.exports = __webpack_public_path__ + "img/fr.3639bfad.svg";